// Single source of truth for attachment constraints, shared by apps/api
// (validateSubmission - the actual enforcement) and apps/web (display only,
// e.g. "対応形式: JPG / PNG..."). Moved here from apps/api/src/config/limits.ts
// specifically so the Mini App can never show a format/size the backend
// wouldn't actually accept.

const IMAGE_MIME_TYPES: string[] = ["image/jpeg", "image/png", "image/webp", "image/gif"];

const DOCUMENT_MIME_TYPES: string[] = [
  "application/pdf",
  "text/plain",
  "text/csv",
  "application/json",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
];

export const FILE_LIMITS = {
  // Applies across every field in one submission, on top of any per-field
  // maxFiles set on the form definition.
  MAX_ATTACHMENTS_PER_SUBMISSION: 10,
  IMAGE: { MAX_SIZE_BYTES: 10 * 1024 * 1024, ALLOWED_MIME_TYPES: IMAGE_MIME_TYPES },
  DOCUMENT: { MAX_SIZE_BYTES: 20 * 1024 * 1024, ALLOWED_MIME_TYPES: DOCUMENT_MIME_TYPES },
} as const;

// Short display extension per MIME type, for the Mini App's "対応形式"
// hint - purely cosmetic, validation always runs against ALLOWED_MIME_TYPES.
const MIME_DISPLAY_LABELS: Record<string, string> = {
  "image/jpeg": "JPG/JPEG",
  "image/png": "PNG",
  "image/webp": "WEBP",
  "image/gif": "GIF",
  "application/pdf": "PDF",
  "text/plain": "TXT",
  "text/csv": "CSV",
  "application/json": "JSON",
  "application/msword": "DOC",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "DOCX",
  "application/vnd.ms-excel": "XLS",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "XLSX",
  "application/vnd.ms-powerpoint": "PPT",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": "PPTX",
};

export function formatMimeList(mimeTypes: readonly string[]): string {
  return mimeTypes.map((m) => MIME_DISPLAY_LABELS[m] ?? m).join(" / ");
}

export function formatMaxSize(bytes: number): string {
  return `${Math.round(bytes / (1024 * 1024))}MB`;
}
